import { CompassCardUI } from '@scale/compass-ui/types';
import {
  ResponseBackfillCardShared,
  ResponseBackfillSchemaType,
  RESPONSE_BACKFILL,
  type ResponseBackfillContext,
} from '@scale/genai-compass-shared/cards/response_backfill';
import { faArrowsRotate } from '@fortawesome/pro-solid-svg-icons';
import ResponseBackfillCardComponent from 'react-scale/corp/views/DataCompassCardsV2/action/ResponseBackfillCard/ResponseBackfillCardComponent';

const defaultContext: ResponseBackfillContext = {
  cardType: RESPONSE_BACKFILL,
  section: 'before',
  stepId: '',
  field: '',
  turnIndex: '',
  newValueTemplate: '',
};

export const ResponseBackfillCardInfo: CompassCardUI<ResponseBackfillSchemaType> = {
  ...ResponseBackfillCardShared,
  title: 'Response Backfill',
  icon: 'arrows-rotate',
  toolTip: 'Backfill task response fields with new values',
  defaultContext,
  button: {
    icon: faArrowsRotate,
  },
  legacyComponent: ResponseBackfillCardComponent,
};
